/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React from 'react';

import history from 'Util/History';

import './ServiceCard.scss';

export default function ServicesCard({
    name, image, url, price
}) {
    return (
        <div
          className="HssMain"
          onClick={ () => {
              history.push(url);
          } }
        >
            <div className="HssMain-Card">
                <div className="HssMain-Card-Img">
                    <img src={ image } alt="Show" />
                </div>
                <div className="HssMain-Card-Titles">
                    <h1 className="HssMain-Card-Titles-Name">{ name || '--' }</h1>
                    <h2 className="HssMain-Card-Titles-Price">
                        { price || '--' }
                    </h2>
                    <button className="HssMain-Card-Titles-Button">
                        KNOW MORE
                    </button>
                </div>
            </div>
        </div>
    );
}

// ServicesCard.PropTypes = {
//     name: PropTypes.string.isRequired,
//     image: PropTypes.string.isRequired,
//     url: PropTypes.string.isRequired,
//     price: PropTypes.string.isRequired
// };
